<template>
  <div
    class="the-header shadow-md flex justify-between items-center"
    testek="the-header"
  >
    <div class="flex items-center total-info flex-4">
      <div class="2xl:flex 2xl:ml-6 xl:ml-3 ml-2">
        <div class="flex">
          <div>
            <div
              class="shadow-md bg-white rounded-xl p-2 min-w-20 2xl:min-w-24 xl:min-w-20 2xl:mr-3 xl:mr-2 mr-2 flex justify-center hover:-translate-y-1 hover:scale-110 cursor-pointer"
              @click="dataClick('/product')"
            >
              <div>
                <div
                  class="font-bold 2xl:text-xl xl:text-lg text-base flex justify-center"
                  testek="productNumber"
                >
                  {{ StatisticInfo.product }}
                </div>
                <div class="flex justify-center">
                  {{ $t("i18nProduct.Product") }}
                </div>
              </div>
            </div>
          </div>
          <div
            class="shadow-md bg-white rounded-xl p-2 min-w-20 2xl:min-w-24 xl:min-w-20 2xl:mr-3 xl:mr-2 mr-2 flex justify-center hover:-translate-y-1 hover:scale-110 cursor-pointer"
            @click="dataClick('/customer')"
          >
            <div>
              <div
                class="font-bold 2xl:text-xl xl:text-lg text-base flex justify-center"
                testek="customerNumber"
              >
                {{ StatisticInfo.customer }}
              </div>
              <div class="flex justify-center">
                {{ $t("i18nProduct.Customer") }}
              </div>
            </div>
          </div>
          <div
            class="shadow-md bg-white rounded-xl p-2 min-w-20 2xl:min-w-24 xl:min-w-20 2xl:mr-3 xl:mr-2 mr-2 flex justify-center hover:-translate-y-1 hover:scale-110 cursor-pointer"
            @click="dataClick('/order', 'PLACED')"
          >
            <div>
              <div
                class="font-bold 2xl:text-xl xl:text-lg text-base flex justify-center"
                testek="orderNumber"
              >
                {{ StatisticInfo.odPlace }}
              </div>
              <div class="flex justify-center">
                {{ $t("i18nProduct.Order") }}
              </div>
            </div>
          </div>
          <div
            class="shadow-md bg-white rounded-xl p-2 min-w-20 2xl:min-w-24 xl:min-w-20 2xl:mr-3 xl:mr-2 mr-2 flex justify-center hover:-translate-y-1 hover:scale-110 cursor-pointer"
            @click="dataClick('/order', 'PROCESSING')"
          >
            <div>
              <div
                class="font-bold 2xl:text-xl xl:text-lg text-base flex justify-center"
                testek="orderNumber"
              >
                {{ StatisticInfo.odProcessing }}
              </div>
              <div class="flex justify-center">
                {{ $t("i18nProduct.OrderProcessing") }}
              </div>
            </div>
          </div>
          <div
            class="shadow-md bg-white rounded-xl p-2 min-w-20 2xl:min-w-24 xl:min-w-20 2xl:mr-3 xl:mr-2 mr-2 flex justify-center hover:-translate-y-1 hover:scale-110 cursor-pointer"
            @click="dataClick('/order', 'SHIPPED')"
          >
            <div>
              <div
                class="font-bold 2xl:text-xl xl:text-lg text-base flex justify-center"
                testek="orderNumber"
              >
                {{ StatisticInfo.odShipped }}
              </div>
              <div class="flex justify-center">
                {{ $t("i18nProduct.OrderShipped") }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="ml-4 flex items-center cursor-pointer"
        @click="reloadStatistic"
      >
        <div
          class="icon-24 icon-reload"
          :title="$t('i18nCommon.ReloadData')"
        ></div>
      </div>
    </div>
    <div class="flex items-center flex-3 justify-end">
      <div class="search-text flex mr-4 2xl:w-72 xl:w-44 w-40">
        <a-input
          v-model:value="searchText"
          :placeholder="'keyword'"
          testek="search-input"
          @keydown="handleKeyDownInput"
        >
          <template #addonAfter>
            <SearchOutlined />
          </template>
        </a-input>
      </div>
      <div
        class="icon-24 icon-cart mr-4 cursor-pointer"
        testek="cart"
        @click="
          () =>
            $messageNotification.messageNotification(
              $t('i18nCommon.FeatureUnderDevelop'),
              'info'
            )
        "
      ></div>
      <div class="mr-4">
        <h-dropdown :data="categories" @click="itemClick">
          <template #icon>
            <div class="cursor-pointer icon-24 icon-insert" testek="add"></div>
          </template>
        </h-dropdown>
      </div>
      <div
        class="icon-24 icon-notification mr-4 cursor-pointer"
        testek="notification"
        @click="
          () =>
            $messageNotification.messageNotification(
              $t('i18nCommon.FeatureUnderDevelop'),
              'info'
            )
        "
      ></div>
      <div class="flex user-info">
        <h-dropdown
          @click="userInfoClick"
          :classMenu="'shadow-md bg-black'"
          class="w-96"
        >
          <template #icon>
            <div
              class="icon-24 icon-user mr-4 cursor-pointer"
              testek="icon-user"
            ></div>
          </template>
          <template #before>
            <div class="mt-4 flex justify-center">
              <div>
                <div class="flex justify-center">
                  <div class="icon-24 icon-user" testek="icon-user"></div>
                </div>
                <div class="mt-2 flex justify-center">
                  {{ userProfile.fullName ? userProfile.fullName : "User" }}
                </div>
                <div class="mt-2 flex justify-center">
                  {{ userProfile.email ? userProfile.email : "email" }}
                </div>
              </div>
            </div>
            <div class="mt-6">
              <a-menu class="pl-5 pr-5 pt-1 pb-1">
                <a-menu-item>
                  <h-dropdown
                    @click="changeLanguage"
                    :classMenu="'shadow-md bg-black'"
                    class="w-96"
                    :data="languages"
                  >
                    <template #icon>
                      <div class="flex">
                        <div
                          class="icon-24 mr-8"
                          :class="
                            lang == 'vi' ? 'icon-vietnamese' : 'icon-english'
                          "
                        ></div>
                        <div>
                          {{ $t("i18nCommon.Language") }}
                        </div>
                      </div>
                    </template>
                  </h-dropdown>
                </a-menu-item>
                <a-menu-item class="mt-4" @click="logOut">
                  <div class="flex">
                    <div class="icon-24 mr-8 icon-logout"></div>
                    <div>
                      {{ $t("i18nCommon.Logout") }}
                    </div>
                  </div>
                </a-menu-item>
              </a-menu>
            </div>
          </template>
        </h-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { ModuleAuth, ModuleProduct } from "@/store/module-const";
import { mapActions, mapGetters } from "vuex";
import { config } from "@/configs/config";
import _ from "lodash";
export default {
  display: "TheHeader",
  data() {
    return {
      menus: [],
      searchText: "",
      categories: [],
      languages: [],
      lang: "vi",
    };
  },
  computed: {
    ...mapGetters(["MenuActive"]),
    ...mapGetters(ModuleAuth, ["StatisticInfo"]),
    totalInfo() {
      //Lấy tổng các dữ liệu trong StatisticInfo
      return this.StatisticInfo.product
        ? this.StatisticInfo.product
        : 0 + this.StatisticInfo.customer
        ? this.StatisticInfo.customer
        : 0 + this.StatisticInfo.odPlace
        ? this.StatisticInfo.odPlace
        : 0 + this.StatisticInfo.odProcessing
        ? this.StatisticInfo.odProcessing
        : 0 + this.StatisticInfo.odShipped
        ? this.StatisticInfo.odShipped
        : 0 + this.StatisticInfo.odDelivered
        ? this.StatisticInfo.odDelivered
        : 0 + this.StatisticInfo.odCancelled
        ? this.StatisticInfo.odCancelled
        : 0;
    },

    userProfile() {
      let user = localStorage.getItem("userProfile");
      return user ? JSON.parse(user) : {};
    },
  },
  created() {
    const me = this;
    me.lang = me.$commonFunc.getLanguageToCached();
    me.$i18n.locale = me.lang;
    me.initDataStatic();
  },
  async mounted() {
    if (!this.StatisticInfo || Object.keys(this.StatisticInfo).length <= 0) {
      // Lấy thông tin thông kê số liệu
      await this.getStatisticInfo();
    }

    // Đặt lịch gọi API mỗi 2 phút (120000ms)
    this.intervalId = setInterval(async () => {
      await this.getStatisticInfo();
    }, config.StatisticLoadTimmer);
  },
  beforeDestroy() {
    // Hủy bỏ setInterval khi component bị hủy
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  methods: {
    ...mapActions(ModuleAuth, ["logOutUser", "getStatisticInfo"]),
    ...mapActions(ModuleProduct, ["getProducts"]),
    initDataStatic() {
      const me = this;
      me.categories = me.categories = [
        {
          id: 1,
          display: me.$t("i18nCommon.Product"),
          router: "/create-product",
        },
        {
          id: 2,
          display: me.$t("i18nCommon.Category"),
          router: "/create-category",
        },
        {
          id: 3,
          display: me.$t("i18nCommon.Supplier"),
          router: "/create-supplier",
        },
        {
          id: 4,
          display: me.$t("i18nCommon.Order"),
          router: "/create-order",
        },
        {
          id: 5,
          display: me.$t("i18nCommon.Customer"),
          router: "/create-customer",
        },
        {
          id: 7,
          display: me.$t("i18nCommon.SaleEmployee"),
          router: "/create-employee",
        },
        {
          id: 8,
          display: me.$t("i18nCommon.AddItem"),
          router: "/create-item",
        },
        {
          id: 9,
          display: me.$t("i18nCommon.User"),
          router: "/create-user",
        },
        {
          id: 10,
          display: me.$t("i18nCommon.Group"),
          router: "/create-group",
        },
      ];
      // if (me.$commonFunc.isTokenExpired()) {
      //   me.menus = config.menus.filter((x) => !x.isAuth);
      // } else {
      //   me.menus = config.menus;
      // }
      me.languages = me.$config.Languages;
      me.checkActive();
    },
    reloadPageCurrent() {
      const me = this;
      me.$router.go(me.$router.currentPage);
    },
    async checkActive() {
      const me = this;
      if (!me.$route || !me.$route.path) return;
      let index = me.menus.findIndex(
        (x) =>
          me.$route.path == "/" ||
          (me.$route.path != "/" &&
            x.router != "/" &&
            me.$route.path.includes(x.router))
      );
      if (index < 0) return;
    },

    btnLogin() {
      const me = this;
      me.$router.push("/login");
    },

    scrollTopPage() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },

    async backHome() {
      const me = this;
      me.$router.push("/");
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },

    handleKeyDownInput(event) {
      //Hỗ trợ key enter
      if (event.keyCode === 13) {
        this.loadDataSearchForm();
      }
    },

    loadDataSearchForm: _.debounce(function (payload) {
      const me = this;
      let router = "/product";
      me.$router.push(router);
      me.$emitter.emit("MenuActive", { router: router });
      setTimeout(() => {
        me.$emitter.emit("LoadDataProduct", { keyword: me.searchText });
      }, 300);

      // //Search API
      // await me.getProducts({});
    }, 300),

    itemClick(item) {
      const me = this;
      if (!item || !item.router) return;
      me.$router.push(item.router);
    },

    userInfoClick() {
      const me = this;
    },
    changeLanguage(language) {
      const me = this;
      me.lang = language.lang;
      me.$commonFunc.setLanguageToCached(me.lang);
      me.$i18n.locale = me.lang;
      me.initDataStatic();
      me.reloadPageCurrent();
      me.$emitter.emit("LoadLanguage", {});
    },

    dataClick(router, status) {
      const me = this;

      if (me.$route.path != router) {
        me.$router.push(router);
      }
      setTimeout(() => {
        me.$emitter.emit("MenuActive", { router: router });
        if (status) {
          me.$emitter.emit("LoadDataOrder", { status: status });
        }
      }, 300);
    },

    async logOut() {
      this.$router.push("/login");
      // await this.logOutUser();
      this.$auth.logout();
    },

    reloadStatistic: _.debounce(async function () {
      const me = this;
      await me.getStatisticInfo();
    }, 500),
  },
};
</script>

<style lang="scss" scoped>
@import url("@/assets/contents/scss/layout/TheHeader.scss");
</style>
